import { Box } from '@mui/material'
import { useContext, useEffect } from 'react'
import { useCategories } from '../hooks/useCategories'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { ADD_CATEGORY, CATEGORIES } from '../constants'
import { ContentHead } from '../components/common/ContentHead'
import { CardBox } from '../theme/styleComponents'
import { SearchWithKeypress } from '../components/common/SearchWithKeypress'
import { flexCenter } from '../theme/styleConstants'
import { EmptyData } from '../components/common/EmptyData'
import CategoryListing from '../components/entries/categories'
import CategoryModal from '../components/entries/categories/CategoryModal'

// others
// components
const CategoryContainer = () => {
  const { categories, pagination, loading, refetch } = useCategories({})
  const { isOpen, dispatch } = useContext(AppContext)

  const isEmpty = !loading && categories.length === 0
  const searchText = 'Search Category'

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })
  
  useEffect(()=>{
    dispatch({type: ActionType.SET_CURRENT_PAGE, currentPage: pagination?.page || 1})
    dispatch({type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: pagination?.totalPages || 1})
  },[dispatch, pagination?.page, pagination?.totalPages])
  
  return (
    <CardBox marginTop={3}>
      <ContentHead title={CATEGORIES} buttonText={ADD_CATEGORY} backButton/>

      <Box display={'flex'} justifyContent={'flex-start'} m={2}>
        <SearchWithKeypress searchPlaceholder={searchText} />
      </Box>

      { isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
            <EmptyData title={'No Categories!'} />
          </Box>
        ) : (
          <CategoryListing categories={categories} loading={loading} refetch={refetch} />
        )
      }
      <CategoryModal isOpen={isOpen} handleClose={handleClose} refetch={refetch}/>
    </CardBox>
  )
}

export default CategoryContainer